import { useLoadInitialPermissionsEffect, useWatchDevicesEffect, } from '../state/mediaState';
import { useClockEffect } from '../state/timeState';
import { useViewportSizeUpdaterEffect } from '../utils';
export function GlobalEffects() {
    useViewportSizeUpdaterEffect();
    useWatchDevicesEffect();
    useClockEffect();
    useLoadInitialPermissionsEffect();
    return null;
}
